/**
 * JOD Animations — John Oliver Designs
 * Scroll reveal (Intersection Observer) + header scroll shadow
 * Vanilla JS, no dependencies
 */
(function () {
  'use strict';

  /* ── Respect reduced-motion preference ── */
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Scroll Reveal ── */
  function initScrollReveal() {
    var sections = document.querySelectorAll('.jod-scroll-reveal');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('jod-revealed');

          /* Stagger children */
          var children = entry.target.querySelectorAll('.jod-scroll-reveal-child');
          children.forEach(function (child, i) {
            child.style.transitionDelay = prefersReduced ? '0s' : (i * 0.1) + 's';
          });

          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  /* ── Header Scroll Shadow ── */
  function initHeaderScroll() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    var threshold = 50;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          if (window.scrollY > threshold) {
            header.classList.add('jod-header-scrolled');
          } else {
            header.classList.remove('jod-header-scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollReveal();
      initHeaderScroll();
    });
  } else {
    initScrollReveal();
    initHeaderScroll();
  }
})();
